export default "__VITE_ASSET__BKE3Ym2W__"